






































import { defineComponent, ref, useRouter } from '@nuxtjs/composition-api'
import CContainer from '~/components/shared/configurable/grid/CContainer.vue'
import CBreadcrumbs from '~/components/shared/configurable/CBreadcrumbs.vue'
import CIcon from '~/components/shared/configurable/CIcon.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CForm from '~/components/shared/configurable/form/CForm.vue'
import CFormGroup from '~/components/shared/configurable/form/CFormGroup.vue'
import CInput from '~/components/shared/configurable/form/input/CInput.vue'
import CButton from '~/components/shared/configurable/button/CButton.vue'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import { ciSearchbarMagnifier } from '~/icons/source/regular/searchbar-magnifier'
import { useI18n } from '~/compositions/i18n'
import { useLogger } from '~/compositions/logger'
import { useDeps } from '~/compositions/dependency-container'
import SearchClassifiedByIdService from '~/services/classified/SearchClassifiedByIdService'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import SnackbarService from '~/services/snackbar/SnackbarService'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  components: {
    CContainer,
    CBreadcrumbs,
    CIcon,
    CCard,
    CForm,
    CFormGroup,
    CInput,
    CButton,
    CFormError
  },
  setup() {
    const { t } = useI18n()
    const router = useRouter()
    const logger = useLogger()
    const [
      searchClassifiedByIdService,
      formValidationService,
      snackbar
    ] = useDeps(
      SearchClassifiedByIdService,
      FormValidationBuilder,
      SnackbarService
    )
    const loading = ref(false)
    const classifiedId = ref<string>('')
    const inputError = ref<string | null>(null)
    const breadcrumbs = [
      {
        text: t('search')
      },
      {
        text: t('search classified with id')
      }
    ]

    const validateInput = () => {
      inputError.value = formValidationService
        .new()
        .maxChars(10, classifiedId.value)
        .minChars(1, classifiedId.value)
        .isNumeric(classifiedId.value)
        .validate()
    }

    const search = async () => {
      if (inputError.value) return

      loading.value = true

      try {
        const { url } = await searchClassifiedByIdService.search(
          parseInt(classifiedId.value)
        )

        return router.push(url)
      } catch (error) {
        if (!error.response) {
          logger.captureError(error as any)
        }

        snackbar.error(t('classified_not_found'))
      } finally {
        loading.value = false
      }
    }

    return {
      ciSearchbarMagnifier,
      breadcrumbs,
      classifiedId,
      loading,
      inputError,
      validateInput,
      search
    }
  },
  i18n: defineComponentTranslations({
    classified_not_found: {
      en:
        'Classified not found! Verify the classified id you entered and try again.',
      el:
        'Η αγγελία δεν βρέθηκε! Επαλήθευσε τον αριθμό αγγελίας που καταχώρισες και προσπάθησε ξανά.'
    }
  })
})
